import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { color } from '../../Assets/color';
import { fonts } from '../../Assets/fonts';
import { colorNames } from '../../Constants/colors';

const flexBox = css`
    display: flex;
`;

const columnFlexDirection = css`
    flex-direction: column;
`;

const justifyCenter = css`
    justify-content: center;
`;

const alignCenter = css`
    align-items: center;
`;

const alignLeft = css`
    align-items: flex-start;
`;

const alignRight = css`
    align-items: flex-end;
`;

export const MainContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const ContentInMiddle = styled.div`
    width: 100%;
    height: 100%;

    ${flexBox};
    ${justifyCenter};
    ${alignCenter};
`;

export const Row = styled.div`
    ${flexBox};

    margin-top: ${props => (props.marginTop ? props.marginTop : null)};
    margin-right: ${props => (props.marginRight ? props.marginRight : null)};
    margin-left: ${props => (props.marginLeft ? props.marginLeft : null)};
    margin-bottom: ${props => (props.marginBottom ? props.marginBottom : null)};
    width: ${props => (props.width ? props.width : 'auto')};
    justify-content: ${props => (props.justify ? props.justify : 'flex-start')};
    align-items: ${props => (props.align ? props.align : 'center')};
    height: ${props => (props.fullHeight ? '100%' : null)};
    flex-wrap: ${props => (props.wrap ? 'wrap' : null)};
    max-width: ${props => (props.maxWidth ? props.maxWidth : null)}
    justify-self: ${props => (props.justifySelf ? props.justifySelf : null)};
    cursor: ${props => (props.cursor ? props.cursor : null)};

    // &:nth-child(odd) > p {
    //     margin-right: 6px;
    // }
`;

export const Column = styled.div`
    ${flexBox};
    ${columnFlexDirection};

    height: ${props => (props.height ? props.height : '100%')};
    width: ${props => (props.width ? props.width : 'auto')}
    justify-content: ${props => (props.justify ? props.justify : null)};
    max-width: ${props => (props.maxWidth ? props.maxWidth : null)};
    margin-left: ${props => (props.marginLeft ? props.marginLeft : null)};

    align-items: ${props => {
        if (props.alignCenter) {
            return 'center';
        }

        return null;
    }};

    ${props => {
        if (props.align) {
            switch (props.align) {
                case 'left':
                    return alignLeft;
                case 'center':
                    return alignCenter;
                case 'right':
                    return alignRight;
                default:
                    return;
            }
        }

        return null;
    }};
`;

export const InCenter = styled.div`
    ${flexBox};
    ${justifyCenter};
`;

export const OuterIndent = styled.div`
    margin: ${props => (props.indent ? props.indent : null)};
`;

export const HoverableLink = styled(Link)`
    transition: all 0.25s;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        opacity: 0.75;
    }
`;

export const OuterMargin = styled.div`
    margin-left: ${props => (props.left ? props.left : null)};
    margin-right: ${props => (props.right ? props.right : null)};
    margin-top: ${props => (props.top ? props.top : null)};
    margin-bottom: ${props => (props.bottom ? props.bottom : null)};
    margin: ${props => (props.margin ? props.margin : null)};
`;

export const SpaceBetweenRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const CenterRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// refactored
export const RootContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${color(colorNames.WHITE)};
    display: flex;
    flex-direction: column;
`;

export const RootContentContainer = styled.div`
    width: 100%;
    flex: 1;
    background-color: ${color(colorNames.MAIN_BLACK)};
`;

export const ContainerWithNavs = styled.div`
    width: 100%;
    height: 100%;
    padding-top: 45px;
`;

// button
export const Button = styled.button`
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: ${color('white')};
    border: none;
    outline: none;
    padding: 14px 30px;
    font-family: ${fonts('regular')};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;

    &:hover {
        cursor: pointer;
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }

    transition: all 0.25s;
`;

export const SemiTransparentButton = styled(Button)`
    background-color: rgba(255, 255, 255, 0.25);
    text-transform: uppercase;
    border-radius: 100px;
    font-weight: 500;

    &:hover {
        background-color: rgba(255, 255, 255, 0.15);
    }

    &:disabled {
        &:hover {
            background-color: rgba(255, 255, 255, 0.25);
        }
    }
`;

// text
export const Text = styled.p`
    text-transform: ${props => (props.uppercase ? 'uppercase' : null)};
    font-size: ${props => {
        if (props.small) {
            return '12px';
        } else if (props.medium) {
            return '16px';
        } else if (props.large) {
            return '20px';
        } else if (props.fontSize) {
            return `${props.fontSize}px`;
        }

        if (props.size) {
            return props.size;
        }

        return '14px';
    }};
    font-weight: ${props => (props.weight ? props.weight : 'normal')};
    text-align: ${props => (props.center ? 'center' : null)};
    color: ${props => (props.color ? color(props.color) : color('white'))};
    opacity: ${props => (props.opacity ? props.opacity : '1')};
    padding: ${props => (props.padding ? props.padding : null)};
    margin-left: ${props => (props.marginLeft ? props.marginLeft : '0')};
    margin-right: ${props => (props.marginRight ? props.marginRight : '0')};
    margin-top: ${props => (props.marginTop ? props.marginTop : '0')};
    margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '0')};
    max-width: ${props => (props.maxWidth ? props.maxWidth : null)};
    text-overflow: ${props => (props.textOverflow ? props.textOverflow : null)};
    overflow: ${props => (props.overflow ? props.overflow : null)};
    cursor: ${props => (props.cursor ? props.cursor : null)};

    font-style: normal;
    font-stretch: normal;
    line-height: ${props => {
        if (props.lineHeight) {
            return props.lineHeight;
        }
        return 1.2;
    }};

    font-family: ${props => {
        if (props.fontDeebby) {
            return fonts('custom');
        }

        return fonts('regular');
    }};
    letter-spacing: 0px;

    text-align: ${props => {
        if (props.left) {
            return 'left';
        } else if (props.alignCenter) {
            return 'center';
        }
        return null;
    }};

    white-space: ${props => {
        if (props.nowrap) {
            return 'nowrap';
        } else if (props.wrapText) {
            return 'initial';
        } else {
            return null;
        }
    }};

    & > a {
        font-family: ${fonts('normal')};
        color: ${color('white')};
    }

    ${props => {
        if (props.hover) {
            return `
                &:hover {
                    ${props.hover}
                }
            `;
        }
    }};

    ${props => {
        if (props.upperFirestCharacter) {
            return `&::first-letter {
                text-transform: uppercase;
             }`;
        } else {
            return null;
        }
    }};

    transition: ${props => {
        if (props.transition) return props.transition;
    }};
`;

export const ThinText = styled(Text)`
    font-weight: 300;
`;

// input
export const Input = styled.input`
    width: 100%;
    height: 30px;
    font-size: 14px;
    padding-left: 20px;
    outline: none;
    border: none;
    border-radius: 3px;
    color: ${color(colorNames.WHITE)};

    ::placeholder {
        color: ${color(colorNames.WHITE)};
        opacity: 0.75;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Layouts/index.js